import React from 'react';
import FeatherIcon from 'feather-icons-react';
import { Modal, Button, Row, Col } from 'antd';
import PropTypes from 'prop-types';
import { ContentDescription, ContentModalVerification, TextError } from './style';
import { DOCUMENT_VALIDATE, ERROR_VALIDATION_TYPES } from '../../config/constants/documentErrorConstants';
import { useDictionaryTranslation } from '../../hooks/useDictionaryTranslation';

export const IdentificationValidatorErrorModal = ({ isVisible, onClose, errors, selectedDocumentType }) => {
  const { translate: t } = useDictionaryTranslation();

  const getErrorParams = (error) => {
    const errorParams = { documentType: selectedDocumentType?.description };

    Object.keys(ERROR_VALIDATION_TYPES).forEach((key) => {
      const errorData = error?.errors?.find((dataError) => dataError.type === ERROR_VALIDATION_TYPES[key]);
      if (errorData) {
        errorParams[key] = errorData.value;
      }
    });

    return errorParams;
  };

  const getTranslatedErrorMessage = (error) => {
    const errorType = DOCUMENT_VALIDATE[error?.message];
    const errorParams = getErrorParams(error);
    return t(errorType?.label, errorParams);
  };

  return (
    <Modal visible={isVisible} footer={null} width={400} closable={null}>
      <Col md={24}>
        <ContentModalVerification gutter={40}>
          <Col md={3}>
            <FeatherIcon icon="alert-circle" className="icons" size={25} style={{ color: '#fa8b0f' }} />
          </Col>
          <Col md={21}>
            <ContentDescription>
              <Col md={24}>
                <TextError>{t('verificationDocumentText')}</TextError>
                <p>{getTranslatedErrorMessage(errors)}</p>
              </Col>
            </ContentDescription>
          </Col>
        </ContentModalVerification>
      </Col>

      <Row justify="end">
        <Button type="primary" onClick={onClose}>
          {t('ok')}
        </Button>
      </Row>
    </Modal>
  );
};

IdentificationValidatorErrorModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    message: PropTypes.string.isRequired,
    errors: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.string.isRequired,
        value: PropTypes.number,
      }),
    ).isRequired,
  }).isRequired,
  selectedDocumentType: PropTypes.shape({
    description: PropTypes.string.isRequired,
  }).isRequired,
};
